// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { RejectedReason } from '@innolab-trader/tradovate-types/src/enums/rejectedReason'

export interface LiquidatePosition {
  accountId: number
  contractId: number
  admin: boolean
  customTag50?: string
  isAutomated?: boolean
}

export interface PlaceOrderResult {
  failureReason?: RejectedReason
  failureText?: string
  orderId?: number
}

/**
 * Validate LiquidatePosition request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateLiquidatePosition(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateLiquidatePosition(request: LiquidatePosition): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.accountId === undefined || req.accountId === null) {
    errors.push({
      field: 'accountId',
      code: 'required',
      message: 'accountId is required'
    })
  }

  if (req.contractId === undefined || req.contractId === null) {
    errors.push({
      field: 'contractId',
      code: 'required',
      message: 'contractId is required'
    })
  }

  if (req.admin === undefined || req.admin === null) {
    errors.push({
      field: 'admin',
      code: 'required',
      message: 'admin is required'
    })
  }

  if (typeof req.customTag50 === 'string' && req.customTag50.length > 64) {
    errors.push({
      field: 'customTag50',
      code: 'too_long',
      message: 'customTag50 must not exceed 64 characters',
      argument: '64'
    })
  }

  return errors
}

export const liquidatePosition = postEndpoint<LiquidatePosition, PlaceOrderResult>('/order/liquidatePosition')
